import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const Lapbukubesar = (periode, data, namaBulan, tahun, namaAkun, posisi, saldoAwal) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};
const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(logoDataUrl, "PNG", logoX, logoY, logoSize, logoSize);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);
};

  namaBulan = namaBulan || "Tidak Diketahui";
  namaAkun = namaAkun || "Nama Akun Tidak Diketahui";
  const periodeTahun = periode?.toString().substring(0, 4) || "Tidak Diketahui";
  const kodePerkiraan = data[0]?.kdperk || "Tidak Diketahui";

  const titleLines = [
    "Laporan Buku Besar",
    `${kodePerkiraan} - ${namaAkun.trim().toUpperCase()}`,
    `${namaBulan} ${periodeTahun}`
  ];

  doc.setFontSize(12);
  let yPos = 40;
  titleLines.forEach(line => {
    doc.text(line, pageWidth / 2, yPos, { align: "center" });
    yPos += 6;
  });

  yPos += 4;
  doc.setFontSize(8);
  doc.text(`Saldo Awal:`, 10, yPos, { align: "left" });

  const saldoAwalFormatted = saldoAwal.toLocaleString("id-ID");
  const textWidth = doc.getTextWidth(saldoAwalFormatted);
  const valueX = pageWidth - 10 - textWidth;
  doc.text(saldoAwalFormatted, valueX, yPos);

  const headers = [[
    { content: "No", styles: { halign: "center" } },
    { content: "Tanggal", styles: { halign: "center" } },
    { content: "No. Bukti", styles: { halign: "center" } },
    { content: "Uraian", styles: { halign: "left" } },
    { content: "Debit", styles: { halign: "right" } },
    { content: "Kredit", styles: { halign: "right" } },
    { content: "Saldo", styles: { halign: "right" } }
  ]];

  const formatNumber = (num) => {
    return num === null || num === undefined || isNaN(num)
      ? "-"
      : parseFloat(num).toLocaleString("id-ID");
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "-";
    try {
      const date = new Date(isoDate);
      return date.toLocaleDateString("id-ID", {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      console.error("Error formatting date", error);
      return "-";
    }
  };

  let runningSaldo = saldoAwal;
  let totalDebit = 0;
  let totalKredit = 0;

  const tableData = data.map((item, index) => {
    const debit = parseFloat(item.debet) || 0;
    const kredit = parseFloat(item.kredit) || 0;

    if(posisi==="D"){
      runningSaldo += debit - kredit;
    }
    else
    {
      runningSaldo += kredit - debit;
    }  
    
    totalDebit += debit;
    totalKredit += kredit;

    return [
      { content: index + 1, styles: { halign: "right" } },
      formatDate(item.jtanggal),
      item.jnobukti || "-",
      item.uraian || "-",
      { content: formatNumber(debit), styles: { halign: "right" } },
      { content: formatNumber(kredit), styles: { halign: "right" } },
      { content: formatNumber(runningSaldo), styles: { halign: "right" } }
    ];
  });

  tableData.push([
    {
      content: "Total",
      colSpan: 4,
      styles: {
        fontStyle: "bold",
        halign: "center",
        fillColor: [230, 230, 230]
      }
    },
    {
      content: formatNumber(totalDebit),
      styles: {
        fontStyle: "bold",
        halign: "right",
        fillColor: [230, 230, 230]
      }
    },
    {
      content: formatNumber(totalKredit),
      styles: {
        fontStyle: "bold",
        halign: "right",
        fillColor: [230, 230, 230]
      }
    },
    {
      content: "",
      styles: {
        fontStyle: "bold",
        halign: "right",
        fillColor: [230, 230, 230]
      }
    }
  ]);

 const renderTable = () => {
  autoTable(doc, {
    head: headers,
    body: tableData,
    startY: yPos + 5,
    theme: "grid",
    styles: { fontSize: 8, cellPadding: 1.5 },
    headStyles: {
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 2
    },
    showHead: "everyPage",
    margin: { left: 9, right: 9 },
    tableWidth: "stretch"
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    drawHeader(logoDataUrl);
    renderTable();
  })
  .catch(() => {
    drawHeader();
    renderTable();
  });
};
export default Lapbukubesar;
